/* ==========================================================================
   Canada Cologne — Momentum buy-box behaviour
   Additive layer on top of canada-cologne.js. Nothing here replaces existing
   logic: the native <select name="id"> size dropdown is the source of truth
   for add-to-cart, variant pricing, stock, gallery swapping and the wishlist.
   ========================================================================== */
(function () {
  'use strict';

  var CC = window.CANADA_COLOGNE || {};

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, event, fn, opts) { if (el) el.addEventListener(event, fn, opts || false); }

  /* --- Size tiles ---------------------------------------------------------
     Tiles are rendered by Liquid; the hidden <select name="id"> stays in the
     form as the source of truth for price, stock, gallery and add-to-cart. */
  function initSizeTiles() {
    $$('[data-cc-size]').forEach(function (picker) {
      var select = $('[data-variant-select]', picker);
      // Bottle sizes and decant sizes are two tile groups driving one select.
      var groups = $$('[data-cc-size-tiles]', picker);
      if (!select || !groups.length || picker.classList.contains('is-single')) return;
      var tiles = $$('.cc-size__tile', picker);

      function sync() {
        tiles.forEach(function (tile) {
          var on = tile.dataset.value === select.value;
          tile.classList.toggle('is-selected', on);
          tile.setAttribute('aria-checked', on ? 'true' : 'false');
          tile.tabIndex = on ? 0 : -1;
        });
      }

      groups.forEach(function (group) {
        group.addEventListener('click', function (event) {
          var tile = event.target.closest('.cc-size__tile');
          if (!tile || tile.disabled || tile.dataset.value === select.value) return;
          select.value = tile.dataset.value;
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });

        group.addEventListener('keydown', function (event) {
          var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
          if (!keys[event.key]) return;
          event.preventDefault();
          var enabled = $$('.cc-size__tile', group).filter(function (tile) { return !tile.disabled; });
          var i = enabled.indexOf(document.activeElement);
          var next = enabled[(i + keys[event.key] + enabled.length) % enabled.length];
          if (next) { next.focus(); next.click(); }
        });
      });

      select.addEventListener('change', sync);
      sync();
    });
  }

  /* Keep the label wrapper in place when variant updates rewrite button text.
     (No bag icon any more — the label stands on its own.) */
  function initAddButtonIcon() {
    $$('[data-add-button]').forEach(function (button) {
      function ensureShape() {
        if ($('[data-add-label]', button) && button.children.length === 1) return;
        var text = (button.textContent || '').trim() || 'Add To Cart';
        var label = document.createElement('span');
        label.setAttribute('data-add-label', '');
        label.textContent = text;
        button.replaceChildren(label);
      }

      ensureShape();
      if ('MutationObserver' in window) {
        new MutationObserver(ensureShape).observe(button, { childList: true });
      }
    });
  }

  /* --- Buy it now / More payment options ---------------------------------
     Replaces Shopify's dynamic checkout button. Adds the selected variant to
     the cart, then goes straight to checkout, where every payment method the
     shop offers (Shop Pay, cards, wallets) is available. Both the Buy It Now
     button and the "More payment options" link run this same flow. */
  function initBuyNow() {
    var triggers = $$('[data-cc-buy-now]');
    if (!triggers.length) return;
    var root = (CC.routes && CC.routes.root) || CC.rootUrl || '/';

    triggers.forEach(function (button) {
      var form = button.closest('form') || $('#MainProductForm');
      if (!form) return;
      var label = $('[data-cc-buy-now-label]', button) || button;

      on(button, 'click', function () {
        if (button.disabled) return;
        var idField = form.querySelector('[name="id"]');
        var qtyField = form.querySelector('[name="quantity"]');
        var id = idField && idField.value;
        if (!id) return;
        var quantity = Math.max(1, parseInt(qtyField && qtyField.value, 10) || 1);

        var original = label.textContent;
        var isLink = button.hasAttribute('data-cc-more-payment');
        button.disabled = true;
        button.classList.add('is-busy');
        // The link just goes; only the Buy It Now button reports progress.
        if (!isLink) {
          label.innerHTML = '<span class="cc-btn-state"><span class="cc-btn-spinner" aria-hidden="true"></span><span>Processing…</span></span>';
        }

        fetch(root.replace(/\/$/, '') + '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: quantity }] })
        })
          .then(function (response) {
            if (!response.ok) return response.json().then(function (data) { throw data; });
            window.location.href = root.replace(/\/$/, '') + '/checkout';
          })
          .catch(function (error) {
            button.disabled = false;
            button.classList.remove('is-busy');
            label.innerHTML = '<span class="cc-btn-state"></span>';
            label.firstChild.textContent = original;
            var message = (error && (error.description || error.message)) || 'Could not start checkout. Please try again.';
            window.alert(message);
          });
      });

      // Coming back from checkout with the browser's Back button restores the
      // page from cache still showing "Processing…" — put the label back.
      window.addEventListener('pageshow', function (event) {
        if (!event.persisted || !button.classList.contains('is-busy')) return;
        button.classList.remove('is-busy');
        var add = $('[data-add-button]', form);
        button.disabled = add ? add.disabled : false;
        label.textContent = button.hasAttribute('data-cc-more-payment') ? 'More Payment Options' : 'Buy Now';
      });

      // Follow the add-to-cart button's availability.
      var add = $('[data-add-button]', form);
      if (add && 'MutationObserver' in window) {
        new MutationObserver(function () {
          button.disabled = add.disabled;
        }).observe(add, { attributes: true, attributeFilter: ['disabled'] });
      }
    });
  }

  /* "Get In Touch" opens the header's Contact support panel rather than
     navigating away, so the shopper keeps their place on the listing. */
  function initSupportLink() {
    var links = $$('[data-cc-open-support]');
    if (!links.length) return;

    links.forEach(function (link) {
      on(link, 'click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var toggle = $('[data-contact-toggle="support"]');
        if (!toggle) {
          window.location.href = 'mailto:canadacologne@gmail.com';
          return;
        }

        var header = toggle.closest('header') || toggle.parentElement;
        var offscreen = header && header.getBoundingClientRect().bottom < 40;

        function open() {
          if (toggle.getAttribute('aria-expanded') !== 'true') toggle.click();
        }

        if (offscreen) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          window.setTimeout(open, 420);
        } else {
          window.setTimeout(open, 0);
        }
      });
    });
  }

  /* Keep the original header dropdowns and blur the page behind all three. */
  function initDropdownBackdrop() {
    /* Search uses the same backdrop: the desktop results panel and the phone search panel. */
    var panels = $$('[data-cart-preview], [data-wishlist-preview], [data-contact-preview], #HeaderPredictiveSearch, [data-compact-search-panel]');
    if (!panels.length) return;
    /* v2.16.31 — cc706: phones show and hide the backdrop instantly. */
    var phoneQuery = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
    var motionMsFor = function () { return phoneQuery && phoneQuery.matches ? 0 : 600; };
    var backdropOpen = false;
    var hideTimer = 0;
    var timingTimer = 0;

    var scrim = document.createElement('div');
    scrim.className = 'cc-dropdown-scrim';
    scrim.setAttribute('aria-hidden', 'true');
    scrim.hidden = true;
    document.body.appendChild(scrim);

    function sync() {
      var visible = false;
      var entering = false;
      var settled = false;
      panels.forEach(function (panel) {
        if (!panel.hidden) {
          visible = true;
          if (panel.classList.contains('is-opening')) entering = true;
          else if (!panel.classList.contains('is-closing')) settled = true;
        }
        var wrap = panel.parentElement;
        if (wrap) wrap.classList.toggle('cc-dropdown-panel-active', !panel.hidden);
      });

      // Prepare the transparent scrim while the panel is in its opening state.
      // Start both transitions when is-opening is removed; start both exits
      // as soon as is-closing is added, before the panel gets [hidden].
      if (visible && scrim.hidden) {
        scrim.hidden = false;
        scrim.getBoundingClientRect();
      }
      var open = settled || (backdropOpen && entering);
      if (open !== backdropOpen) {
        backdropOpen = open;
        document.body.classList.add('cc-dropdown-timing');
        clearTimeout(timingTimer);
        timingTimer = setTimeout(function () {
          document.body.classList.remove('cc-dropdown-timing');
        }, motionMsFor() + 40);
      }

      if (open) {
        clearTimeout(hideTimer);
        hideTimer = 0;
        if (scrim.hidden) {
          scrim.hidden = false;
          scrim.getBoundingClientRect();
        }
        scrim.classList.add('is-open');
      } else {
        scrim.classList.remove('is-open');
        if (!entering && (visible || !scrim.hidden) && !hideTimer) {
          hideTimer = setTimeout(function () {
            hideTimer = 0;
            if (!backdropOpen) scrim.hidden = true;
          }, motionMsFor() + 20);
        }
      }
      document.body.classList.toggle('cc-dropdown-visible', visible);
      document.body.classList.toggle('cc-dropdown-open', open);
    }

    if ('MutationObserver' in window) {
      panels.forEach(function (panel) {
        new MutationObserver(sync).observe(panel, { attributes: true, attributeFilter: ['hidden', 'class'] });
      });
    }

    sync();
  }

  function boot() {
    initSizeTiles();
    initAddButtonIcon();
    initBuyNow();
    initSupportLink();
    initDropdownBackdrop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* --- Sale badge optical centring -------------------------------------------
   Centres every "% OFF" / "SALE" badge on the visual middle of the price's
   capital letters ("$48.99 CAD"), not on the line box, which sits lower
   because fonts reserve room for descenders. It also centres the badge's own
   text inside the pill. Offsets come from the live font metrics, so the result
   holds on every product page and product card, at every screen size, and with
   whatever fallback font a device ends up using. */
(function () {
  'use strict';
  var PAIRS = [
    { row: '.simple-product-price-line', price: 'strong', badge: '.simple-sale-badge' },
    { row: '.full-bottle-strip-price', price: 'strong', badge: 'em' },
    // "Free Local Pickup (?)": the circle sits on the middle of the capital letters,
    // lifted 0.5px because Windows font hinting renders this small bold text a touch high.
    { row: '.cc-pickup-chip__title', price: 'strong', badge: '.cc-pickup-chip__icon', sample: 'FLP', nudge: -0.5 }
  ];
  var K = 20; // measure at 20x size for sub-pixel precision
  var ctx = null;
  var scheduled = 0;

  function capCenter(el, sample, mixed) {
    var node = null;
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) { node = n; break; }
    }
    if (!node) return null;
    var cs = getComputedStyle(el);
    var size = parseFloat(cs.fontSize) || 0;
    if (!size) return null;
    ctx = ctx || document.createElement('canvas').getContext('2d');
    ctx.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + (size * K) + 'px ' + cs.fontFamily;
    var m = ctx.measureText(sample);
    if (!m || typeof m.fontBoundingBoxAscent !== 'number') return null;
    var asc = m.fontBoundingBoxAscent / K;
    var desc = m.fontBoundingBoxDescent / K;
    var cap = m.actualBoundingBoxAscent / K;
    if (mixed) cap = (cap + ctx.measureText('x').actualBoundingBoxAscent / K) / 2;
    var range = document.createRange();
    range.selectNodeContents(node);
    var rects = range.getClientRects();
    if (!rects.length) return null;
    var line = rects[rects.length - 1];
    var baseline = line.top + (line.height - (asc + desc)) / 2 + asc;
    return baseline - cap / 2;
  }

  function px(value) { return (Math.round(value * 100) / 100) + 'px'; }

  function alignOne(row, pair) {
    var price = row.querySelector(pair.price);
    var badge = row.querySelector(pair.badge);
    if (!price || !badge || !badge.getClientRects().length || !price.getClientRects().length) return;

    // 1) Text inside the pill: shift it with asymmetric padding (badge is border-box, fixed height).
    var box = badge.getBoundingClientRect();
    var inner = capCenter(badge, 'OFF');
    if (inner != null) {
      var shift = (parseFloat(badge.dataset.ccTextShift) || 0) + ((box.top + box.height / 2) - inner);
      if (Math.abs(shift) < 0.05) shift = 0;
      badge.dataset.ccTextShift = String(shift);
      badge.style.setProperty('padding-top', px(Math.max(0, shift * 2)), 'important');
      badge.style.setProperty('padding-bottom', px(Math.max(0, -shift * 2)), 'important');
    }

    // 2) The pill itself: move it so its centre sits on the price's cap-height centre.
    // Skip when the badge has wrapped onto its own line (nothing to line up with).
    var priceRects = price.getClientRects();
    var lastLine = priceRects[priceRects.length - 1];
    box = badge.getBoundingClientRect();
    if (box.top >= lastLine.bottom - 1 || box.bottom <= lastLine.top + 1) {
      badge.style.removeProperty('translate');
      badge.dataset.ccBadgeShift = '0';
      return;
    }
    var target = capCenter(price, pair.sample || 'CAD', pair.mixed);
    if (target == null) return;
    var current = parseFloat(badge.dataset.ccBadgeShift) || 0;
    var next = current + (target + (pair.nudge || 0) - (box.top + box.height / 2));
    if (Math.abs(next) < 0.05) next = 0;
    badge.dataset.ccBadgeShift = String(next);
    if (next) badge.style.setProperty('translate', '0 ' + px(next), 'important');
    else badge.style.removeProperty('translate');
  }

  function alignAll() {
    scheduled = 0;
    PAIRS.forEach(function (pair) {
      var rows = document.querySelectorAll(pair.row);
      for (var i = 0; i < rows.length; i++) {
        try { alignOne(rows[i], pair); } catch (e) { /* never block the page */ }
      }
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = window.requestAnimationFrame(alignAll);
  }

  function start() {
    schedule();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
    if (document.fonts && document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', schedule);
    window.addEventListener('load', schedule);
    window.addEventListener('pageshow', schedule);
    var resizeTimer = 0;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(schedule, 120);
    });
    // Product cards loaded later (recommendations, recently viewed, filters,
    // infinite scroll) and variant changes that rewrite the price line.
    if ('MutationObserver' in window) {
      var rowsSelector = PAIRS.map(function (p) { return p.row; }).join(',');
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var r = records[i];
          var host = r.target.nodeType === 1 ? r.target : r.target.parentElement;
          if (host && host.closest && host.closest(rowsSelector)) { schedule(); return; }
          for (var j = 0; j < r.addedNodes.length; j++) {
            var n = r.addedNodes[j];
            if (n.nodeType === 1 && (n.matches(rowsSelector) || n.querySelector(rowsSelector))) { schedule(); return; }
          }
        }
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* --- Product-page tooltips stay on screen ------------------------------------
   Tooltips open right next to what was tapped/hovered (same as desktop). On a
   narrow phone a tooltip can poke past the screen edge, so nudge it sideways
   (via --cc-tip-nudge) just enough to keep a 12px margin. */
(function () {
  'use strict';
  var EDGE = 12;
  var frame = 0;
  function fit() {
    frame = 0;
    var vw = document.documentElement.clientWidth || window.innerWidth;
    var tips = document.querySelectorAll('.cc-product-page .cc551-tester-tooltip');
    for (var i = 0; i < tips.length; i++) {
      var tip = tips[i];
      tip.style.setProperty('--cc-tip-nudge', '0px');
      var r = tip.getBoundingClientRect();
      if (!r.width) continue;
      var nudge = 0;
      if (r.right > vw - EDGE) nudge = (vw - EDGE) - r.right;
      if (r.left + nudge < EDGE) nudge = EDGE - r.left;
      if (nudge) tip.style.setProperty('--cc-tip-nudge', (Math.round(nudge * 100) / 100) + 'px');
    }
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(fit); }
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  // Re-check right before a tooltip shows (layout may have changed since load).
  ['pointerdown', 'focusin', 'mouseover'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var t = event.target;
      if (t && t.closest && t.closest('.cc551-tester-help, .cc-pickup-chip, .cc-image-note')) fit();
    }, { passive: true, capture: true });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();

/* --- Phone shelf swiping -------------------------------------------------------
   Phones (<= 640px): New Arrivals, Best Sellers, Flash Sale, You May Also Like and
   Recently Viewed are plain horizontal scroll rails. The finger drags the products
   directly, momentum and CSS scroll-snap settle them on a card edge, and the arrows
   simply glide the rail one screen-full. (The homepage shelves used to jump one
   page per flick with a fade; the product-page shelves re-snapped with a fade after
   every swipe.) Desktop keeps its existing arrow paging. */
(function () {
  'use strict';
  var mq = window.matchMedia ? window.matchMedia('(max-width: 640px)') : null;
  var HOME = '.product-section-home [data-cc246-wrap]';
  var PDP = '.source-product-shelf .source-shelf-wrap';

  function isPhone() { return !!(mq && mq.matches); }
  function rowOf(wrap) { return wrap.querySelector('[data-cc246-row], [data-shelf-row]'); }
  function cardsOf(row) {
    return Array.prototype.filter.call(row.children, function (c) {
      return c.classList && c.classList.contains('full-bottle-strip-card') && !c.hidden;
    });
  }
  function arrows(wrap) {
    return {
      prev: wrap.querySelector('[data-cc246-prev], [data-shelf-prev]'),
      next: wrap.querySelector('[data-cc246-next], [data-shelf-next]')
    };
  }
  function syncArrows(wrap) {
    var row = rowOf(wrap);
    if (!row) return;
    if (wrap.classList.contains('cc-fade-pager')) {
      var fi = fadeInfo(row);
      if ((wrap._ccFadePage || 0) > fi.pages - 1) wrap._ccFadePage = fi.pages - 1;
      fadeArrows(wrap, fi, wrap._ccFadePage || 0);
      return;
    }
    var a = arrows(wrap);
    var max = row.scrollWidth - row.clientWidth;
    if (a.prev) a.prev.disabled = row.scrollLeft <= 2;
    if (a.next) a.next.disabled = row.scrollLeft >= max - 2;
  }
  // One "page": as many whole cards as fit in the visible part of the rail.
  function pageStep(row) {
    var cards = cardsOf(row);
    if (cards.length < 2) return row.clientWidth;
    var step = cards[1].offsetLeft - cards[0].offsetLeft;
    if (step <= 0) return row.clientWidth;
    var cs = getComputedStyle(row);
    var visible = row.clientWidth - (parseFloat(cs.scrollPaddingLeft) || 0) - (parseFloat(cs.scrollPaddingRight) || 0);
    var gap = step - cards[0].offsetWidth;
    return Math.max(1, Math.floor((visible + gap + 1) / step)) * step;
  }

  // Same dissolve as the Flash Sale: dim to 12% in 240ms, swap, fade back in (520ms).
  // Pages are counted in whole listings and land exactly on a listing's edge.
  function fadeInfo(row) {
    var cards = cardsOf(row);
    if (cards.length < 2) return { cards: cards, per: 1, pages: Math.max(1, cards.length) };
    var step = cards[1].offsetLeft - cards[0].offsetLeft;
    var per = step > 0 ? Math.max(1, Math.round(pageStep(row) / step)) : 1;
    return { cards: cards, per: per, pages: Math.max(1, Math.ceil(cards.length / per)) };
  }
  function fadeOffset(info, page) {
    var cards = info.cards;
    if (!cards.length) return 0;
    var start = Math.max(0, Math.min(page * info.per, cards.length - info.per));
    // Snap down to a whole pixel (scroll positions are whole pixels) so the first
    // listing on the page never loses its left edge.
    return Math.max(0, Math.floor(cards[start].getBoundingClientRect().left - cards[0].getBoundingClientRect().left + 0.01));
  }
  function fadeArrows(wrap, info, page) {
    var a = arrows(wrap);
    if (a.prev) a.prev.disabled = page <= 0;
    if (a.next) a.next.disabled = page >= info.pages - 1;
  }
  function fadePage(wrap, dir) {
    var row = rowOf(wrap);
    if (!row) return;
    var info = fadeInfo(row);
    var from = wrap._ccFadePage || 0;
    var page = Math.max(0, Math.min(info.pages - 1, from + dir));
    if (page === from) return;
    wrap._ccFadePage = page;
    fadeArrows(wrap, info, page);
    var viewport = wrap.querySelector('[data-cc246-viewport]') || row;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var swap = function () {
      row.scrollLeft = fadeOffset(fadeInfo(row), wrap._ccFadePage || 0);
      fadeArrows(wrap, fadeInfo(row), wrap._ccFadePage || 0);
    };
    if (reduce || !viewport) { swap(); return; }
    clearTimeout(wrap._ccFadeTimer);
    viewport.classList.add('cc-fade-pager-out');
    wrap._ccFadeTimer = setTimeout(function () {
      swap();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { viewport.classList.remove('cc-fade-pager-out'); });
      });
    }, 240);
  }

  // v77: one swipe for every product shelf (New Arrivals, Best Sellers, You May Also
  // Like, Recently Viewed). Phones: the swipe fades to the next/previous page.
  // Tablets and desktop: the swipe does exactly what the arrow does.
  function bindSwipe(wrap, row) {
    if (wrap._ccFadeSwipeBound) return;
    wrap._ccFadeSwipeBound = true;
    var startX = null, startY = null;
    row.addEventListener('touchstart', function (event) {
      if (!event.touches || event.touches.length !== 1) { startX = null; return; }
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });
    row.addEventListener('touchend', function (event) {
      if (startX === null || !event.changedTouches || !event.changedTouches.length) return;
      var dx = event.changedTouches[0].clientX - startX;
      var dy = event.changedTouches[0].clientY - startY;
      startX = null;
      if (!(Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy))) return;
      var dir = dx < 0 ? 1 : -1;
      if (isPhone()) { fadePage(wrap, dir); return; }
      var a = arrows(wrap);
      var control = dir > 0 ? a.next : a.prev;
      if (control && !control.disabled && !control.hidden) control.click();
    }, { passive: true });
    row.addEventListener('touchcancel', function () { startX = null; }, { passive: true });
  }

  function enable(wrap) {
    var row = rowOf(wrap);
    if (!row) return;
    var home = wrap.matches(HOME);
    if (home && !wrap.classList.contains('cc-swipe')) {
      wrap.classList.add('cc-swipe', 'cc-fade-pager');
      wrap._ccFadePage = 0;
      row.scrollLeft = 0;
      cardsOf(row).forEach(function (card) { card.classList.add('is-visible'); });
    }
    // v77: You May Also Like / Recently Viewed page with the same fade as the homepage.
    if (!home && !wrap.classList.contains('cc-fade-pager')) {
      wrap.classList.add('cc-fade-pager');
      wrap._ccFadePage = 0;
      row.scrollLeft = 0;
    }
    bindSwipe(wrap, row);
    // A rail shows every card. Clear anything the older one-card-at-a-time
    // paging left behind (it can run before the rail is set up), or those
    // cards stay inert and ignore taps even though they are on screen.
    if (home) {
      cardsOf(row).forEach(function (card) {
        card.classList.remove('cc647-flash-active', 'cc650-phone-pair-active', 'cc650-phone-pair-hidden');
        card.removeAttribute('aria-hidden');
        if ('inert' in card) card.inert = false;
      });
    }
    if (!wrap._ccSwipeBound) {
      wrap._ccSwipeBound = true;
      row.addEventListener('scroll', function () {
        if (!isPhone()) return;
        if (wrap._ccSwipeFrame) return;
        wrap._ccSwipeFrame = requestAnimationFrame(function () { wrap._ccSwipeFrame = 0; syncArrows(wrap); });
      }, { passive: true });
    }
    syncArrows(wrap);
  }
  function clearFade(wrap) {
    wrap._ccFadePage = 0;
    clearTimeout(wrap._ccFadeTimer);
    var row = rowOf(wrap);
    var fadeView = wrap.querySelector('[data-cc246-viewport]') || row;
    if (fadeView) fadeView.classList.remove('cc-fade-pager-out');
  }
  function disable(wrap) {
    if (!wrap.matches(HOME)) {
      // Leaving phone width: the desktop shelf paging takes over again.
      if (!wrap.classList.contains('cc-fade-pager')) return;
      wrap.classList.remove('cc-fade-pager');
      clearFade(wrap);
      var pdpRow = rowOf(wrap);
      if (pdpRow) pdpRow.scrollLeft = 0;
      return;
    }
    if (!wrap.classList.contains('cc-swipe')) return;
    wrap.classList.remove('cc-swipe', 'cc-fade-pager');
    clearFade(wrap);
    var row = rowOf(wrap);
    if (row) row.scrollLeft = 0;
    // Let the desktop paging redraw itself from page 1.
    var prev = wrap.querySelector('[data-cc246-prev]');
    if (prev) { wrap.dataset.cc246Page = '1'; prev.disabled = false; prev.click(); }
  }

  function apply() {
    var wraps = document.querySelectorAll(HOME + ', ' + PDP);
    for (var i = 0; i < wraps.length; i++) {
      var row = rowOf(wraps[i]);
      if (row) bindSwipe(wraps[i], row);
      if (isPhone()) enable(wraps[i]);
      else disable(wraps[i]);
    }
  }

  // Arrows on phones: every shelf pages with the Flash Sale fade (v76 homepage, v77 product page).
  document.addEventListener('click', function (event) {
    if (!isPhone()) return;
    var control = event.target.closest && event.target.closest('[data-cc246-prev], [data-cc246-next], [data-shelf-prev], [data-shelf-next]');
    if (!control) return;
    var wrap = control.closest(HOME + ', ' + PDP);
    var row = wrap && rowOf(wrap);
    if (!row) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var dir = control.matches('[data-cc246-next], [data-shelf-next]') ? 1 : -1;
    fadePage(wrap, dir);
  }, true);

  var timer = 0;
  function later() { clearTimeout(timer); timer = setTimeout(apply, 150); }
  if (mq && mq.addEventListener) mq.addEventListener('change', apply);
  window.addEventListener('resize', later, { passive: true });
  window.addEventListener('load', later);
  document.addEventListener('shopify:section:load', later);
  document.addEventListener('cc:listings-updated', later);
  // Homepage shelves fill in their randomized products after load; recently
  // viewed / recommendations render late too. Re-apply when cards appear.
  if ('MutationObserver' in window) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (t.nodeType === 1 && t.matches && t.matches('[data-cc246-row], [data-shelf-row]')) { later(); return; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
})();
